import React from "react";

export default function OneStaff({ passport, name, description }) {
  return (
    <div className="col-12 col-md-3 p-3 text-center">
      {/* Staff Photo */}
      <div
        className="rounded overflow-hidden mx-auto border"
        style={{
          width: "170px",
          height: "170px",
          backgroundImage: `url(${passport})`,
          backgroundSize: 'cover',
          backgroundPosition: "center",
        }}
      ></div>

      {/* Staff Name */}
      <h5 className="mt-3">{name}</h5>

      {/* Staff Description */}
      <p style={{ fontSize: "0.9rem", color: "#555" }}>{description}</p>
    </div>
  );
}
